import React from 'react';
import { FiAlertCircle, FiXCircle } from "react-icons/fi";
import { SurveyOutcomeCard } from "pages/SurveyComplete/SurveyOutcomeCard";

export const UserTerminate = ({ isHmacFailed }: any) => {
  return (
    <SurveyOutcomeCard
      tone={isHmacFailed ? "danger" : "warning"}
      icon={isHmacFailed ? FiXCircle : FiAlertCircle}
      title={isHmacFailed ? `Survey Terminated` : `Almost, but not quite!`}
      actions={
        <a href="/join-now" className="zs-btn zs-btn-primary zs-btn-lg zs-btn-block">
          Browse My Surveys
        </a>
      }
    >
      <p>
        This one wasn&apos;t a match based on your profile — but there are plenty more waiting.
        Find your next survey and start earning.
      </p>
    </SurveyOutcomeCard>
  );
};
